import RestClient from "@/api/utils/baseRestClient";
import waitForTask from "@/api/utils/waitForTask";
import { atmoClient } from "@/setup/clients/atmoClient";
import { toReportFormPayload } from "@/composables/reportSteppers/reportFormPayload";

const EXPORT_TIMEOUT_MS = 15 * 60 * 1000;
const EXPORT_PICKUP_TIMEOUT_MS = 5 * 60 * 1000;

class ReportExportRestClient extends RestClient {
  async startQal2AstExport({
    projectUuid,
    dataToDisplayForm,
    generationFormUuid,
    exportFormat,
  }) {
    const { data } = await this.client.post(this.buildUrl("export"), {
      project_uuid: projectUuid,
      data_to_display_form: toReportFormPayload(dataToDisplayForm),
      generation_form_uuid: generationFormUuid,
      export_format: exportFormat,
    });
    return this.toCamel(data);
  }

  async waitForQal2AstExport(taskId) {
    const result = await waitForTask(
      this.client,
      this.buildUrl(`export/${taskId}`),
      `QAL2/AST export task ${taskId}`,
      {
        timeoutMs: EXPORT_TIMEOUT_MS,
        pickupTimeoutMs: EXPORT_PICKUP_TIMEOUT_MS,
      }
    );
    return this.toCamel(result);
  }

  async listQal2AstExports(projectUuid) {
    const { data } = await this.client.get(
      this.buildUrl("export", { project_uuid: projectUuid })
    );
    return this.toCamel(data);
  }

  async destroyQal2AstExport(taskId, projectUuid) {
    await this.client.delete(
      this.buildUrl(`export/${taskId}`, { project_uuid: projectUuid })
    );
  }
}

export const reportExportRestClient = new ReportExportRestClient(
  atmoClient,
  "reports"
);
